import { render, staticRenderFns } from "./WelcomeCard.vue?vue&type=template&id=2986fe6e&"
import script from "./WelcomeCard.vue?vue&type=script&lang=js&"
export * from "./WelcomeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports